import { useAuthContext } from "../../../contexts/auth-context";
import { useRouteNavigation } from "../../../lib/common/routes";

export const HowItWorks = () => {
    const { navigateRouteClickHandler } = useRouteNavigation();
    const { isLoggedIn, userInfo } = useAuthContext();

    return (
        <>
            <div className="container-fluid image-section-howitworks image-section-howitworks__lab ">
                {/* Dental Labs Section */}
                <div className="container">
                    <div className="row p-3 p-md-5">
                        <div className="col-9 col-lg-5 text-container-black text-container-black__labs px-4 px-md-5 text-white">
                            <div className="row pb-3 ps-1 fs-4">
                                <strong>DENTAL EMPLOYERS</strong>
                            </div>
                            <div className="row ps-3 fs-5 mb-0 fw-bold">
                                SCRAMBLING AROUND FOR GOOD DENTAL TALENT?
                            </div>
                            <div className="row pt-4 ps-3">
                                Maybe you're looking in all the wrong places. At
                                a time when talent is in high demand, dental
                                employers around the country are finding it
                                harder and harder to hire qualified talent.
                            </div>
                            <div className="row pt-3 ps-3">
                                And yet, today's impersonal supermarket job
                                sites with their dry generic job listings fail
                                to serve both dental employers and the
                                candidates that are seeking their ideal job.
                            </div>
                            <div className="mt-4">
                                <button
                                    className="btn btn-readMore px-4"
                                    onClick={(e) =>
                                        navigateRouteClickHandler("story", e)
                                    }
                                >
                                    READ MORE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid image-section-howitworks image-section-howitworks__tech">
                {/* Dental Tech Section */}
                <div className="container">
                    <div className="row p-3 p-md-5">
                        <div className="col-9 col-lg-5 text-container-white p-4 p-md-5 text-black">
                            <div className="row pb-3 ps-1 fs-4">
                                <strong>DENTAL TALENT</strong>
                            </div>
                            <div className="row ps-3 fs-5 mb-0 fw-bold">
                                CURIOUS WHAT OPPORTUNITIES ARE OUT THERE?
                            </div>
                            <div className="row pt-4 ps-3">
                                In today's dental market, job candidates are
                                extremely valuable and that's good. But what if
                                you're not happy where you are? That's where we
                                come in.
                            </div>
                            <div className="row pt-3 ps-3">
                                Signing up makes you visible to dental employers
                                around the country. They can invite you to take
                                a look at their profile. You decide if you want
                                to explore the invite or decline it.
                                <br />
                                <br />
                                <p className="p-0">
                                    <strong>Pretty cool right?</strong>
                                </p>
                                <p className="px-0 p1-2">
                                    <strong>Feels good to be in demand.</strong>
                                </p>
                            </div>
                            <div className="mt-4">
                                <button
                                    className="btn btn-readMore px-4"
                                    onClick={(e) =>
                                        navigateRouteClickHandler(
                                            !!isLoggedIn &&
                                                userInfo?.type === "tech"
                                                ? "dentalLabSearch"
                                                : "signupTech",
                                            e
                                        )
                                    }
                                    disabled={
                                        !!isLoggedIn &&
                                        userInfo?.type !== "tech"
                                    }
                                >
                                    {!!isLoggedIn
                                        ? userInfo?.type === "tech"
                                            ? "Find Your Perfect Job"
                                            : `You are logged in as employer`
                                        : "Sign Up"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
